import { useEffect, useState } from 'react'
import { NextRouter } from 'next/router'
import { getGamesBySearchAndCategory } from '@/utils/helper'

export interface Game {
  id: string
  title: string
  slug: string
  description?: string
  thumb: string
  url?: string
  typeId?: string
  gameId?: string
  category: string
  tags: string
}

// 全局游戏数据缓存
let cachedGames: Game[] = []

// 初始化标志
let isInitialized = false

// 基础获取全部游戏数据方法
export async function getAllGames(): Promise<Game[]> {
  // 如果已有缓存且已初始化，直接返回
  if (isInitialized && cachedGames.length > 0) {
    return cachedGames
  }

  const host = process.env.NEXT_PUBLIC_HOST
  try {
    const response = await fetch(`${host}/gamelist.json`, {
      headers: { Accept: 'application/vnd.dpexpo.v1+json' },
      cache: 'no-store',
    })

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`)
    }

    cachedGames = await response.json()
    isInitialized = true
    return cachedGames
  } catch (error) {
    console.error('Failed to fetch games:', error)
    return []
  }
}

// 根据路由规则获取特定数据
export async function getGamesByRoute(router: NextRouter): Promise<Game[]> {
  const allGames = await getAllGames()
  const { asPath } = router
  // 安全获取 pathname 的多种方式
  const pathname =
    // Next.js 路由对象
    (router as any)?.pathname ||
    // 兼容 getServerSideProps 的 context
    (router as any)?.req?.url ||
    // 客户端路由
    (router as any)?.asPath?.split('?')[0]

  //  /recommended 路由 - 推荐游戏
  if (pathname === '/recommended') {
    return allGames.filter((game) => game.typeId === '002')
  }

  // /hot-games 路由 - 热门游戏
  if (pathname === '/hot-games') {
    return allGames.filter((game) => game.typeId === '003')
  }
  // 默认返回全部游戏
  return allGames
}

// 获取初始化后的游戏数据（同步）
export function getInitializedGames(): Game[] {
  if (!isInitialized) {
    console.warn('Accessing games before initialization')
  }
  return cachedGames
}
